module.exports = __webpack_public_path__ + "img/mathilde.87c82dd4.jpg";